export default {
	pages: {
		home: "Welcome to outdoor gear store!",
		products: "Products",
		interactive: "Interactive Gear Explorer",
		environmental: "Our commitment to the environment",
		admin: "Admin",
		cart: "Cart",
		login: "Login",
	},
	interactive_gear_explorer: {
		title: 'Interactive Gear Explorer',
		steps: {
			0: 'What activity are you planning?',
			1: 'What is your budget?',
			2: 'Those are the recommended products for you!'
		},
		buttons: {
			hiking: 'Hiking',
			climbing: 'Climbing',
			camping: 'Camping',
		}
	},
	header: {
		home: 'Home',
		admin: 'Admin',
		interactive: 'Interactive Gear Explorer',
		environmental: 'Environmental Commitment',
		products: 'Products',
		cart: 'Cart',
		login: 'Login',
		logout: 'Logout',
	},
	product_card: {
		add_to_cart: 'Add to Cart',
		goto_product: 'Go to Product',
		remove_from_cart: 'Remove',
	},
	environment: {
		title: 'Our Environmental Commitments',
		sustainable_materials: {
			title: 'Sustainable Materials',
			description: 'We ensure all our materials are sourced from suppliers who comply with our strict sustainability criteria.',
		},
		energy_efficiency: {
			title: 'Energy Efficiency',
			description: 'Our manufacturing processes are optimized for minimum energy consumption, aiming to reduce our carbon footprint.',
		},
		waste_reduction: {
			title: 'Waste Reduction',
			description: 'We actively reduce waste through recycling initiatives and by designing products that have a longer life cycle.',
		},
		green_packaging: {
			title: 'Green Packaging',
			description: 'Transitioning to sustainable packaging solutions, we aim to minimize the use of non-decomposable materials.',
		},
		ecological_conservation: {
			title: 'Ecological Conservation',
			description: 'Supporting various ecological conservation programs, we strive to protect the natural environment that is crucial for our survival.',
		},
		education_and_collaboration: {
			title: 'Education and Collaboration',
			description: 'Through educational initiatives and collaborations, we\'re raising environmental awareness and encouraging greener practices within the outdoor industry.',
		},
	},
	products: {
		title: 'Our Products',
		categories: {
			all: "All",
			sleeping_bags: "Sleeping Bags",
			tents: "Tents",
			camping_chairs: "Camping Chairs",
			camping_tables: "Camping Tables",
			portable_lights: "Portable Lights",
			stoves: "Stoves",
			coolers: "Coolers",
			tools: "Tools",
			backpacks: "Backpacks",
			other: "Other",
			kits: "Kits",
			footwear: "Footwear",
			undefined: "Unknown",
		}
	},
	login: {
		title: 'Login',
		emailPlaceholder: 'Email',
		passwordPlaceholder: 'Password',
		submit: 'Log-In',
		signup: 'New to our store?',
		signupDescription: 'Sign up now to enjoy exclusive benefits!',
		signupBenefit: 'Get the latest news and updates on our products',
		signupBenefit2: 'Receive special offers and discounts',
	},
	footer: {
		title: 'Outdoor Gear Store',
		menu: {
			title: 'Menu',
			home: 'Home',
			products: 'Products',
			interactive: 'Interactive Gear Explorer',
			environmental: 'Environmental Commitment',
			cart: 'Cart',
			login: 'Login',
		},
		information: {
			title: 'Information',
			about: 'About Us',
			contact: 'Contact Us',
			privacy: 'Privacy Policy',
			terms: 'Terms & Conditions',
			careers: 'Careers',
		},
	},
	cart: {
		title: 'Shopping Cart',
		total: 'Total value is {{total}}',
	},
	admin: {
		title: 'Admin Panel',
		table: {
			name: 'Name',
			email: 'Email',
			open_cart: 'Open Cart',
		}
	},
	home: {
		title: 'Gear Up For Outdoors',
		products: 'Explore Our Products',
		environmental: 'Our Environmental Commitments',
		interactive: 'Try Our Interactive Gear Explorer',
	},
	product: {
		title: 'Product Details',
		carbon_footprint: 'Carbon footprint',
		recyclable_materials: 'Recyclable material',
		end_of_life_options: 'End of Life',
		add_to_cart: 'Add to cart',
	},
};
